import Vue from 'vue';
import dateTime from 'date-time';

export default Vue.extend({
    data() {
        return { value: '', value1: '' };
    },
    created() {
        this.value = this.params.value;
    },
    mounted() {
        Vue.nextTick(() => {
            // need to check if the input reference is still valid - if the edit was cancelled before it started there
            // wont be an editor component anymore
            if (this.$refs.input) {
                this.$refs.input.focus();
            }
        });
    },
    methods: {
        onChange(event) {
            this.value1 = event.srcElement.value;
            if (/[0-9]{4}-[0-9]{2}/.test(this.value1)) {
                this.value = this.value1;
                this.value1 = '';
            }
        },
        getValue() {
            return this.value;
        }
    },
    template: `
        <el-date-picker
            v-model="value"
            type="month"
            :ref="'input'"
            @input.native="onChange"
            value-format="yyyy-MM"
            style="width: 100%"
        ></el-date-picker>
    `
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/datePicker.js